<template>
  <auth-template>
    <form @submit.prevent="requestReset">
      <h2>{{ env }}Forgotten Password</h2>

      <b-alert variant="info" show v-if="isComplete">
        <strong>E-mail Sent</strong>
        <div>
          We have sent you an e-mail to reset your password
        </div>
      </b-alert>

      <div v-else>
        <div class="element">
          <input
            required
            v-model="form.email"
            type="email"
            placeholder="E-mail Address"
          />
        </div>

        <b-button type="submit" variant="success">Reset Password</b-button>
      </div>

      <hr />

      <div>
        <span @click="loadLogin" class="password-link">Back to login</span>
      </div>
    </form>
  </auth-template>
</template>

<script>
import AuthTemplate from "@/views/Auth/AuthTemplate.vue";
import { recaptcha } from "@/components/mixins/recaptcha";

export default {
  name: "PasswordForgot",
  components: { AuthTemplate },
  mixins: [recaptcha],
  data() {
    return {
      loading: false,
      isComplete: false,
      form: {
        email: ""
      }
    };
  },
  computed: {
    env() {
      return process.env.VUE_APP_ENV;
    }
  },
  methods: {
    loadLogin() {
      this.$router.push("/login");
    },
    async requestReset() {
      const title = "Initiating Reset";
      const subtitle = "Please wait a moment";
      await this.$store.dispatch("loaderInitiate", { title, subtitle });

      const token = await this.recaptchaToken();

      const email = this.form.email;
      this.$store
        .dispatch("passwordForgot", { email, token })
        .then(() => {
          this.isComplete = true;
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: err
          });
        })
        .finally(() => {
          this.$store.dispatch("loaderCancel");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.password-link {
  cursor: pointer;
  font-size: 0.8rem;
}

h2 {
  text-align: center !important;
  font-size: 1.4rem !important;
}

h3 {
  font-size: 1.1rem;
}
</style>
